import { render, staticRenderFns } from "./PriceTab.vue?vue&type=template&id=3e3e72ef&"
import script from "./PriceTab.vue?vue&type=script&lang=js&"
export * from "./PriceTab.vue?vue&type=script&lang=js&"
import style0 from "./PriceTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports